module.exports = __webpack_public_path__ + "static/media/mammal.695ad8ab.mov";